import {IS_LOADING} from '../actions/actiontypes';
import initialState from './initialstate';

const loadingReducer = (state = initialState.isLoading, action) => {
	switch (action.type) {
		case IS_LOADING:
			return action.isLoading;
		default:
			return state;
	}
};

export default loadingReducer;
